import React from "react";
import "./loading.css";

const LoadingPage = () => {
  return (
    <div className="loading-container" role="status" aria-live="polite">
      <div className="travel-loader" aria-hidden="true">
        <span>HP26</span>
      </div>
      <p>Preparing your route...</p>
    </div>
  );
};

export default LoadingPage;
